import { gql } from '@apollo/client';

export default gql`
  mutation CancelHotelJacTravel($bookingReference: String!) {
    refund(bookingReference: $bookingReference, method: NONE, hotel: true) {
      ... on NoRefundMethodResult {
        success
      }
    }
  }
`;
